const locations_en = [
  {
    id: "alverca",
    payment_methods: ["cash", "card"],
    pin: [38.8904648, -9.0399861],
    city: "Alverca",
    location: "Sociedade Filarmónica Recreio Alverquense",
    status: "online",
    address: ["Praça da Sociedade Filarmónica Recreio Alverquense", "2615-391"],
    openingTimes: ["Monday to Saturday: 10:00 AM to 7:00 PM"],
    description: "Located in the heart of Alverca, in the Lisbon district, this Bitcoin ATM is conveniently situated inside the café of the Sociedade Filarmónica Recreio Alverquense. It's an excellent choice for anyone looking to buy Bitcoin and other cryptocurrencies quickly, securely, and with ease (cash and card accepted!). With extended opening hours and free on-site parking, it's ideal for both locals and visitors.",
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/32584/bitcoin-atm-general-bytes-alverca-do-ribatejo-sociedade-filarmonica-recreio-alverquense/"
  },
  {
    id: "braga",
    payment_methods: ["cash"],
    pin: [41.5608, -8.3859],
    city: "Braga",
    location: "Yah Atlântico Business Center",
    status: "online",
    address: [
      "Variante do Fojo - Rua Padre Carmelitas",
      "Yeah Atlântico Building, 4719-005"
    ],
    openingTimes: [
      "Monday to Friday: 9:00 AM to 6:00 PM"
    ],
    description: "Located in the Yah Atlântico Business Center in Nogueira – Braga, this Bitcoin ATM is a top choice for professionals, locals, and tourists heading to the Bom Jesus do Monte. Conveniently placed in the building's lobby on the right-hand side, it offers a fast and secure way to buy Bitcoin and other cryptocurrencies. Free on-site parking is available.",
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/56122/bitcoin-atm-general-bytes-braga-yeah-atlantico/"
  },
  {
    payment_methods: ["cash"],
    id: "caldas",
    pin: [39.4101244, -9.1401931],
    city: "Caldas da Rainha",
    location: "Washstation - Self-Service Laundry",
    status: "online",
    address: ["R. José Filipe Neto Rebelo 2A", "2500-222 Caldas da Rainha"],
    openingTimes: ["Every day: 7:00 AM to 9:00 PM"],
    description: "Located in the self-service laundry, this ATM is a great option for those looking to buy Bitcoin while doing their laundry in the Leiria district! Go inside and you'll immediately find it. It has extended opening times. Free parking is available on the street.",
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/63354/bitcoin-atm-general-bytes-caldas-da-rainha-wash-station-lavandaria/"
  },
  {
    id: "faro",
    payment_methods: ["cash", "card"],
    pin: [37.0288821, -7.945],
    city: "Faro",
    location: "Forum Algarve",
    status: "online",
    address: ["Forum Algarve N125", "8009-020"],
    openingTimes: ["Monday to Sunday: 10:00 AM to 11:00 PM"],
    description: "Located in the Forum Algarve shopping center in Faro, this ATM is a great option for those looking to buy Bitcoin while shopping or dining. It is located outdoors, on the ground floor, near Auchan supermarket. Free parking available on site.",
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/35267/bitcoin-atm-general-bytes-faro-forum-algarve/"
  },
  {
    id: "funchal",
    payment_methods: ["cash", "card"],
    pin: [32.6513518, -16.905181],
    city: "Funchal",
    location: "IPRO Clinic / Mais Clinic",
    status: "online",
    address: ["Rua João de Deus, 12B", "9050-027 Funchal"],
    openingTimes: ["Monday to Saturday: 9:00 AM to 8:00 PM"],
    description: "Looking to buy your dental treatment using Bitcoin? Mais Clinic, in Madeira, Funchal is the place to go! While in there, why not buy some crypto using our ATM as well? Buzz your way in and you'll find it immediately on your left hand side.",
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/79247/bitcoin-atm-general-bytes-funchal-mais-clinic/"
  },
  {
    id: "gaia",
    payment_methods: ["cash", "card"],
    pin: [41.13612084, -8.60850771],
    city: "Gaia",
    location: "Power Dot Charging Station - Jardim do Morro",
    status: "online",
    address: ["Rua Rocha Leão 320", "Gaia, 4430-198"],
    openingTimes: ["Monday to Sunday: 9:00 AM to 8:00 PM"],
    description: "Found yourself wondering around the beautiful Jardim do Morro in Gaia? Or perhaps you need to charge your electric vehicle? Why not buy some Bitcoin while you're at it? This ATM is located inside the Power Dot charging station, right next to the entrance.",
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/46528/bitcoin-atm-general-bytes-vila-nova-de-gaia-power-dot-charging-station/"
  },
  {
    id: "lisboa",
    payment_methods: ["cash", "card"],
    pin: [38.72253347583836, -9.133582014684423],
    city: "Lisbon",
    location: "Cotton Club Laundry and Café",
    status: "online",
    address: ["Rua Andrade 15A", "Lisbon, 1170-014"],
    openingTimes: ["Monday to Sunday: 8:00 AM to 9:00 PM"],
    description: "Located in one of the most diverse neighbourhoods right in the heart of Lisbon, this ATM is a great alternative for those looking to buy Bitcoin while doing their laundry or enjoying a coffee. It is located inside the Cotton Club Laundry and Café, on the left hand side as you enter. Look for the stickers!",
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/45145/bitcoin-atm-general-bytes-lisbon-cotton-club-laundry-and-cafe/"
  },
  {
    id: "maia",
    payment_methods: ["cash", "card"],
    pin: [41.259, -8.641],
    city: "Maia",
    location: "TecMaia",
    status: "online",
    address: [
      "Maia Science and Technology Park",
      "Rua Eng.º Frederico Ulrich 2650, 4470-605"
    ],
    openingTimes: ["Monday to Saturday: 10:00 AM to 7:00 PM"],
    description: "Located in the Maia Science and Technology Park (TecMaia), this ATM is a great option for those looking to buy Bitcoin while working or visiting the park. It is located inside the main bulding, next to the café and right by the cash point.",
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/8962/bitcoin-atm-general-bytes-maia-tecmaia/"
  },
  {
    id: "pinhal-novo",
    payment_methods: ["cash", "card"],
    pin: [38.636369,-8.9140826],
    city: "Pinhal Novo",
    location: "Pinhal Hub",
    status: "online",
    address: [
      "Avenida Alexandre Herculano, 56",
      "2955-112 Pinhal Novo"
    ],
    description: "Located in the newly built Pinhal Hub, Pinhal Novo, in the Setúbal district, this ATM is by the main door, you can't miss it! Free Parking is available.",
    openingTimes: ["Monday to Saturday: 10:00 AM to 8:00 PM"],
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/95615/bitcoin-atm-general-bytes-pinhal-novo-pinhal-hub/"
  },
  {
    id: "porto",
    payment_methods: ["cash"],
    pin: [41.14895102696872, -8.608638369338237],
    city: "Porto",
    location: "French Fries Factory",
    status: "online",
    address: ["Rua do Bonjardim 302 Porto, 4000-115"],
    openingTimes: ["Tuesday to Saturday: 12:00 PM to 11:00 PM"],
    description: "Do you like delicious French fries? Do you like Bitcoin? Then this is the place for you! Located inside the French Fries Factory, this ATM is a great option for those looking to buy Bitcoin while enjoying some delicious fries. It is located right next to the entrance, on the left hand side. Bonus: you can pay your fries with Bitcoin!",
    infoLink:
      "https://coinatmradar.com/bitcoin_atm/88331/bitcoin-atm-general-bytes-porto-french-fries-factory/"
  }
];
module.exports = locations_en;

//export default locations_en;
